import { useContext } from 'react';

import { AuthContext, AuthInterface } from 'state/auth';

export default function useAuth(): AuthInterface {
  return useContext(AuthContext);
}
